export const MOBILE_ROW_HEIGHT = 64;
